var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 3.5H8.75C8.28601 3.50046 7.84116 3.68499 7.51307 4.01307C7.18499 4.34116 7.00046 4.78601 7 5.25V24.5C7.00053 24.964 7.18508 25.4088 7.51315 25.7368C7.84123 26.0649 8.28603 26.2495 8.75 26.25H19.25C19.7139 26.2494 20.1587 26.0648 20.4867 25.7367C20.8148 25.4087 20.9994 24.9639 21 24.5V5.25C20.9995 4.78603 20.8149 4.34122 20.4868 4.01315C20.1588 3.68508 19.714 3.50053 19.25 3.5ZM19.25 5.25V7H8.75V5.25H19.25ZM8.75 24.5V8.75H19.25V24.5H8.75Z",
    fill: "#101F43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.944f9d8899ae95b81ddb345d79aa0751.svg";
export { ForwardRef as ReactComponent };